module.exports = __webpack_public_path__ + "img/type_05.98f71f79.png";